(() => {
  const script=document.currentScript;
  if(!script?.dataset.purchaseIndex)return;
  const indexUrl=script.dataset.purchaseIndex,overridesUrl=script.dataset.purchaseOverrides,shards=new Map(),products=new Map(),states=new WeakMap();
  const labels={buy:script.dataset.purchaseBuy,view:script.dataset.purchaseView,checking:script.dataset.purchaseChecking};
  const normalize=value=>String(value||'').toUpperCase().replace(/[^A-Z0-9]/g,'');
  const root=()=>window.Shopify?.routes?.root||'/';
  let manifest,overrides;
  async function json(url){const response=await fetch(url);if(!response.ok)throw Error('Unavailable');return response.json();}
  async function resolveHandle(key){
    if(overridesUrl){
      try{
        overrides ||= json(overridesUrl).catch(error=>{overrides=null;throw error;});
        const match=(await overrides)[key];if(match)return match;
      }catch(error){/* Existing index remains usable if overrides are unavailable. */}
    }
    manifest ||= json(indexUrl).catch(error=>{manifest=null;throw error;});
    const index=await manifest;
    let bucket=0;for(const letter of key)bucket=(bucket*31+letter.charCodeAt(0))%index.files.length;
    const filename=index.files[bucket];
    if(!shards.has(filename))shards.set(filename,json(new URL(filename,indexUrl)).catch(error=>{shards.delete(filename);throw error;}));
    return (await shards.get(filename))[key]||null;
  }
  const skuSearch=new Map();
  async function discoverHandle(sku,key){
    if(skuSearch.has(key))return skuSearch.get(key);
    const request=(async()=>{
      try{
        const url=new URL(root()+'search',location.origin);
        url.searchParams.set('type','product');url.searchParams.set('q',sku);url.searchParams.set('view','er-native-products');
        const preview=new URL(location.href).searchParams.get('preview_theme_id');if(preview)url.searchParams.set('preview_theme_id',preview);
        const result=await json(url);
        const product=(result.products||[]).find(p=>(p.variants||[]).some(v=>normalize(v.sku)===key));
        return product?.handle||null;
      }catch{return null;}
    })();
    skuSearch.set(key,request);return request;
  }
  async function resolve(sku){
    const key=normalize(sku);if(!key)return null;
    try{
      let handle=await resolveHandle(key).catch(()=>null);
      if(!handle)handle=await discoverHandle(sku,key);
      if(!handle)return null;
      const cached=products.get(handle);
      if(!cached||Date.now()-cached.time>15000){
        const url=new URL(root()+'products/'+encodeURIComponent(handle)+'.js',location.origin);
        const preview=new URL(location.href).searchParams.get('preview_theme_id');if(preview)url.searchParams.set('preview_theme_id',preview);
        products.set(handle,{time:Date.now(),promise:json(url).catch(()=>null)});
      }
      const product=await products.get(handle).promise;
      const variant=product?.variants?.find(v=>normalize(v.sku)===key);if(!variant)return null;
      const url=new URL(root()+'products/'+encodeURIComponent(product.handle),location.origin);
      url.searchParams.set('variant',variant.id);
      const preview=new URL(location.href).searchParams.get('preview_theme_id');if(preview)url.searchParams.set('preview_theme_id',preview);
      return {product,variant,url:url.pathname+url.search};
    }catch{return null;}
  }
  async function connect(link,sku,price,onResolved){
    if(!link)return;
    const previous=states.get(link);
    const state={token:Symbol(),pending:true,label:previous?.label??link.textContent,hidden:previous?.hidden??link.hidden,href:link.getAttribute('href')};
    states.set(link,state);
    const controls=purchaseControls.get(link);if(controls){controls.result=null;controls.add.hidden=true;controls.group.hidden=false;}
    if(!previous)link.addEventListener('click',event=>{if(states.get(link)?.pending)event.preventDefault();});
    link.hidden=state.hidden;link.setAttribute('aria-busy','true');link.textContent=labels.checking;
    const result=await resolve(sku);
    if(states.get(link)!==state)return;
    state.pending=false;link.removeAttribute('aria-busy');
    if(!result){link.textContent=state.label;link.hidden=state.hidden;if(state.href)link.setAttribute('href',state.href);return;}
    link.href=result.url;link.textContent=result.variant.available?labels.buy:labels.view;link.hidden=false;
    if(price)price.textContent=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:window.Shopify?.currency?.active||'USD'}).format(result.variant.price/100);
    if(result.variant.available)purchaseActions(link,result);
    onResolved?.(result);
  }
  const purchaseControls=new WeakMap();
  const purchaseStyle=document.createElement('style');
  purchaseStyle.textContent=`.er-purchase-actions{display:flex;flex-wrap:wrap;align-items:center;gap:12px;margin-top:16px}.er-purchase-actions[hidden]{display:none!important}.er-purchase-actions .er-purchase-button{display:inline-flex!important;align-items:center;justify-content:center;min-height:48px;padding:14px 24px!important;border:1px solid transparent!important;border-radius:0!important;color:#fff!important;font:600 13px/1.3 var(--sans,Arial,sans-serif)!important;text-decoration:none!important;cursor:pointer;transition:background-color .18s,border-color .18s;margin:0!important;width:auto!important}.er-purchase-actions .er-purchase-button[hidden]{display:none!important}.er-purchase-actions .er-buy-now{background:#751a25!important}.er-purchase-actions .er-add-cart{background:#4b533b!important}.er-purchase-actions .er-buy-now:hover{background:#4b533b!important}.er-purchase-actions .er-add-cart:hover{background:#751a25!important}.er-purchase-actions .er-purchase-button:active,.er-purchase-actions .er-purchase-button[aria-busy=true]{background:#000!important}.er-purchase-actions .er-purchase-button:focus-visible{outline:2px solid #000;outline-offset:3px}.er-purchase-actions .er-purchase-button:disabled{opacity:.5;cursor:not-allowed}.er-purchase-status{flex-basis:100%;font-size:13px;line-height:1.5;margin:0}.er-purchase-status:empty{display:none}`;
  document.head.append(purchaseStyle);
  async function purchaseAdd(id,quantity=1){
    const response=await fetch(root()+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id,quantity}]})});
    const data=await response.json();
    if(!response.ok)throw Error(data.description||data.message||'This item could not be added to your cart.');
    return data;
  }
  async function purchaseCount(){
    try{const cart=await json(root()+'cart.js');for(const counter of document.querySelectorAll('.er-cart-button span'))counter.textContent=cart.item_count;for(const link of document.querySelectorAll('.er-cart-button'))link.setAttribute('aria-label','Cart, '+cart.item_count+' items');document.dispatchEvent(new CustomEvent('cart:updated',{detail:cart}));}catch{}
  }
  function purchaseActions(action,result){
    if(!action)return;
    let controls=purchaseControls.get(action);
    if(!controls){
      const group=document.createElement('div');group.className='er-purchase-actions';
      const companion=document.createElement('button');companion.type='button';
      const status=document.createElement('p');status.className='er-purchase-status';status.setAttribute('role','status');status.setAttribute('aria-live','polite');
      const isLink=action.tagName==='A';
      action.before(group);group.append(isLink?action:companion,isLink?companion:action,status);
      controls={group,status,buy:isLink?action:companion,add:isLink?companion:action,action,result:null,busy:false};
      purchaseControls.set(action,controls);
      controls.buy.classList.add('er-purchase-button','er-buy-now');controls.add.classList.add('er-purchase-button','er-add-cart');
      const sync=()=>{const unavailable=action.hidden||action.disabled||action.getAttribute('aria-busy')==='true';companion.hidden=action.hidden;companion.disabled=unavailable||controls.busy;};
      new MutationObserver(sync).observe(action,{attributes:true,attributeFilter:['hidden','disabled','aria-busy']});
      for(const [button,checkout]of [[controls.buy,true],[controls.add,false]])button.addEventListener('click',async event=>{
        if(!controls.result?.variant?.available)return;
        event.preventDefault();event.stopImmediatePropagation();
        if(controls.busy||action.hidden||action.disabled||action.getAttribute('aria-busy')==='true'||!controls.result?.variant?.available)return;
        const selected=controls.result;controls.busy=true;controls.status.replaceChildren();
        controls.buy.setAttribute('aria-busy','true');controls.add.setAttribute('aria-busy','true');if(controls.add!==action)controls.add.disabled=true;
        try{
          const quantity=Number(action.closest('form')?.querySelector('[name=quantity]')?.value)||1;
          await purchaseAdd(selected.variant.id,quantity);
          if(checkout){location.assign(root()+'checkout');return;}
          controls.status.textContent='Added to your cart. ';
          const cartLink=document.createElement('a');cartLink.href=root()+'cart';cartLink.textContent='View cart';controls.status.append(cartLink);
          await purchaseCount();
        }catch(error){controls.status.textContent=error.message||'Please try again.';}
        finally{controls.busy=false;controls.buy.removeAttribute('aria-busy');controls.add.removeAttribute('aria-busy');if(controls.add!==action)controls.add.disabled=Boolean(action.disabled);}
      },true);
      sync();
    }
    controls.result=result;controls.status.replaceChildren();
    controls.buy.textContent='Buy Now';controls.add.textContent='Add to Cart';
    controls.group.hidden=!result?.variant?.available;
    controls.buy.hidden=controls.add.hidden=!result?.variant?.available;
    return controls;
  }


  const nativePurchaseLinks=new WeakMap();
  function enhanceNativePurchases(){
    for(const action of document.querySelectorAll('a[href*="/products/"][href*="variant="]')){
      if(states.has(action)||!/^buy online$|^buy now$|^shop now$/i.test(action.textContent.trim()))continue;
      const href=action.getAttribute('href');if(nativePurchaseLinks.get(action)===href)continue;nativePurchaseLinks.set(action,href);
      const controls=purchaseControls.get(action);if(controls){controls.result=null;controls.add.hidden=true;}
      action.setAttribute('aria-busy','true');
      const url=new URL(href,location.origin),id=url.searchParams.get('variant');
      json(url.pathname+'.js').then(product=>{if(action.getAttribute('href')!==href)return;const variant=product.variants.find(v=>String(v.id)===id);if(variant?.available)purchaseActions(action,{product,variant,url:href});}).catch(()=>{}).finally(()=>{if(action.getAttribute('href')===href)action.removeAttribute('aria-busy');});
    }
    for(const form of document.querySelectorAll('form.product-form[action*="/cart/add"]')){
      const action=form.querySelector('button[type="submit"]'),id=form.querySelector('[name="id"]')?.value;if(!action||!id)continue;
      const current=purchaseControls.get(action);if(current?.result?.variant.id===id&&current.result.variant.available===!action.disabled)continue;
      purchaseActions(action,{variant:{id,available:!action.disabled}});
    }
  }
  let purchaseScanQueued=false;
  const schedulePurchaseScan=()=>{if(purchaseScanQueued)return;purchaseScanQueued=true;requestAnimationFrame(()=>{purchaseScanQueued=false;enhanceNativePurchases();});};
  new MutationObserver(schedulePurchaseScan).observe(document.body,{subtree:true,childList:true,attributes:true,attributeFilter:['href','disabled','hidden','value']});
  document.addEventListener('change',schedulePurchaseScan);schedulePurchaseScan();

  window.EvelRidePurchase={resolve,connect,buttons:purchaseActions};
})();
